import React from 'react';

import Icon_Back from "./../assets/svgs/Icon_Back.svg";
import useScreenOrientation from './helpers/useScreenOrientation';
import { ImageData } from "../data/image.data"

export default function ImageGallery({isVisible, isSidebarVisible, product, color, setMenuView}: any) {

  const [imageList, setImageList] = React.useState<any>([]);
  const [imageIndex, setImageIndex] = React.useState(0);
  const [showFullImage, setShowFullImage] = React.useState(false);
  const [showComponent, setShowComponent] = React.useState(false);

  const isLandscape = useScreenOrientation();

  React.useEffect(() => {
    setImageIndex(0)
    if(product){
      let imageData: any = ImageData()
      let images = imageData[product.id] 
      if(images){
        var image_list: any = [];
        for (let image of images) {
          if (image.active)
            image_list.push(image)
        }
        setImageList(image_list)
      }
    }
  }, [product]);

  React.useEffect(() => {
    if(isVisible === true){
      setShowFullImage(false)
      setShowComponent(true)
    }else{
      setTimeout(() => { setShowComponent(false) }, 1000);
    }
  }, [isVisible]);

  const selectImage = (index: number) => {
    if(index > -1 && index < imageList.length){
      setImageIndex(index)
      setShowFullImage(true)
    }
  };

  const decreaseIndex = () => {
    var index = imageIndex - 1
    if(index < 0){
      index = imageList.length - 1
    }
    selectImage(index)
  };

  const increaseIndex = () => {
    var index = imageIndex + 1
    if(index > imageList.length - 1){
      index = 0
    }
    selectImage(index)
  };

  return (
    <div className={`full-image-gallery-container ${isVisible ? 'transition-fade-in' : 'transition-fade-out'}`}>
      { showComponent && <div className={`image-gallery-container-active`}>
      {isLandscape ?
        <div className={`image-gallery-container ${isSidebarVisible ? '' : 'expand'}`}>
          <div className={`image-gallery-preview-container`}>
              {(imageList as {}[]).map((image: any, index) =>
                <div key={index} className={`image-gallery-preview`} style={{backgroundImage: `url(${image.image})`}} onClick={() => selectImage(index)}></div>
              )}
            </div>
            <div className={`image-gallery-fullview-container ${showFullImage ? '' : 'hidden'}`}>
              <div className={`image-gallery-fullview`} style={{ backgroundImage: `url(${imageList[imageIndex].image})` }}></div>
              <div className={`image-gallery-fullview-options`}>
                <div className={`image-gallery-fullview-title`}>{imageList[imageIndex].name}</div>

                <div className={`image-gallery-fullview-controls`}>
                  <div className={`image-gallery-fullview-arrows`} onClick={() => decreaseIndex()}>
                    <i className={`fa-solid fa-l fa-chevron-left`} style={{ color: `#fff` }} />
                  </div>
                  <div className={`image-gallery-fullview-text`}> 
                    {`${imageIndex+1}/${imageList.length}`}
                  </div>
                  <div className={`image-gallery-fullview-arrows`} onClick={() => increaseIndex()}>
                    <i className={`fa-solid fa-l fa-chevron-right`} style={{ color: `#fff` }} />
                  </div>

                </div>
                
                <div className={`image-gallery-fullview-closebtn`} onClick={() => setShowFullImage(false)}>Cerrar</div>
              </div>
            </div>
        </div>
        :
        <div className={`image-gallery-container-portrait`}>
          { showFullImage ? 
            <div className={`image-gallery-fullview-container-portrait`}>
              {/* TITLE */}
              <div className={`image-gallery-fullview-title-portrait`}>{imageList[imageIndex].name}</div>

              <div className={`image-gallery-fullview-portrait-background`}>
                <div className={`image-gallery-fullview-portrait`} style={{ backgroundImage: `url(${imageList[imageIndex].image})` }}></div>
              </div>
              
              <div className={`image-gallery-fullview-imgs-scroller-portrait`}>
                {(imageList as {}[]).map((image: any, index) =>
                  <div key={index} className={`image-gallery-fullview-thumb-scroller-portrait`} style={{backgroundImage: `url(${image.image})`}} onClick={() => selectImage(index)}>
                  </div>
                )}
              </div>

              {/* <div className={`image-gallery-fullview-closebtn-portrait`} onClick={() => setShowFullImage(false)}>Cerrar</div> */}
              <div className="gallery-button portrait" onClick={() => setShowFullImage(false)}>
                  <img className={`gallery-button-icon`} style={{transform: `rotate(90deg)`}} src={Icon_Back} alt=''/>
                  <div className="gallery-button-text">
                    Cerrar Galería
                  </div>
                </div>
              
            </div>
            :
            <div className={`image-gallery-preview-container-portrait`}>
                <div className="image-gallery-toptitle-portrait">GALERÍA</div>
                <div className="image-gallery-title-portrait">Categoría - Cubierta</div>
                <div className="image-gallery-subtitle-portrait">PRODUCTO - {product.name.toUpperCase()}</div>

                <div className="image-gallery-color-container-portrait">
                  <img className={`image-gallery-color-icon-portrait`} src={color.icon} alt=''/>
                  <div className="image-gallery-color-container-text-portrait">
                    <div className="image-gallery-color-name-portrait">{color.name}</div>
                    <div className="image-gallery-color-info-portrait">{color.description}</div>
                  </div>
                </div>
                
                <div className={`image-gallery-preview-imgs-portrait`}>
                  {(imageList as {}[]).map((image: any, index) =>
                    <div key={index} className={`image-gallery-preview-portrait`} style={{backgroundImage: `url(${image.image})`}} onClick={() => selectImage(index)}>
                    </div>
                  )}
                </div>
                
                <div className="gallery-button portrait" onClick={() => setMenuView("PERSONALIZA")}>
                  <img className={`gallery-button-icon`} style={{transform: `rotate(90deg)`}} src={Icon_Back} alt=''/>
                  <div className="gallery-button-text">
                    Cerrar Galería
                  </div>
                </div>
              
            </div>
          }
        </div>
      }
      </div>
      }
    </div>
  );
}
